import { useState } from "react";
import Button from "../components/button";
import Input from "../components/input";
import { Link } from "react-router-dom";
import api from "../utils/api";

const ForgotPassword = () => {

    const [step, setStep] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [code, setCode] = useState('');

    const handleRecover = (step) => {

        setIsLoading(true);

        api.post('/recover-password', {
            step,
            email,
            password,
            code
        })
        .then(res => {
            setIsLoading(false);
            if(step == 1){
                setStep(2);
            }
            if(step == 2){
                setStep(3);
            }
            if(step == 3){
                alert("Senha trocada. Faça seu login!");
                window.location.href = '/login';
            }
        })
        .catch(err => {
            setIsLoading(false);
        })

    }

    return(
        <>
            <div className="flex items-center justify-center" style={{ minHeight: 'inherit' }}>
                <div className="w-full max-w-xl mx-auto p-4">
                    <h1 className="text-3xl font-bold text-center mb-4">Recuperar senha</h1>

                    {step == 1 && (
                        <>
                            <div className="mb-4">
                                <Input
                                    fullWidth
                                    label="E-mail"
                                    type="email"
                                    value={email}
                                    onChange={(e) => {setEmail(e.target.value)}}
                                    placeholder="Seu e-mail"
                                />
                            </div>
                            {/* Link "Esqueceu a senha" alinhado à direita e mais delicado */}
                            <p className="text-sm text-gray-500 text-right mb-4 hover:text-blue-500">
                                <Link to="/login">Entrar</Link>
                            </p>
                                
                            <Button
                                disabled={!email}
                                isLoading={isLoading}
                                onClick={() => {handleRecover(1)}}
                                fullWidth
                            >
                                Receber código
                            </Button>
                        </>
                    )}

                    {step == 2 && (
                        <>
                            <div className="mb-4">
                                <Input 
                                    fullWidth
                                    label="Código recebido"
                                    type="text"
                                    value={code}
                                    onChange={(e) => {setCode(e.target.value)}}
                                    placeholder="Seu código"
                                />
                            </div>
                            <Button
                                disabled={!code}
                                isLoading={isLoading}
                                onClick={() => {handleRecover(2)}}
                                fullWidth
                            >
                                Validar código
                            </Button>
                        </>
                    )}
                        
                    {step == 3 && (
                        <>
                            <div className="mb-4">
                                <Input 
                                    fullWidth
                                    label="Nova senha"
                                    type="password"
                                    value={password}
                                    onChange={(e) => {setPassword(e.target.value)}}
                                    placeholder="Sua nova senha"
                                />
                            </div>
                            <Button
                                disabled={!password}
                                isLoading={isLoading}
                                onClick={() => {handleRecover(3)}}
                                fullWidth
                            >
                                Salvar nova senha
                            </Button>
                        </>
                    )}
                    
                </div>
            </div>
        </>
    )
}

export default ForgotPassword;